<template>
  <div>
    <prohead></prohead>
    <proindex></proindex>
    <Profooter></Profooter>
  </div>

</template>

<script>
import Prohead from '../components/Prohead'
import Proindex from '../components/Proindex'
import Profooter from "../components/Profooter";
export default {
name: "index",
  components: {Proindex, Prohead,Profooter}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/index.vue